<template>
  <div>
    <v-app-bar app clipped-left :color="getThemeColor" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <div class="title ml-3 mt-4" style="display:block">
        <span v-if="$vuetify.breakpoint.mdAndUp">{{ getAppName }}</span>
        <span v-if="$vuetify.breakpoint.mdAndDown">{{
          getAppName.split(" ")[0]
        }}</span>
        |
        <span class="hidden-sm-and-down">
          <small>{{ getUserSchool.emis }}</small>
          <br />
        </span>
        <SwitchSchool :userId="getCurrentUser.id"></SwitchSchool>
      </div>

      <v-spacer />
      <span class="h3 hidden-sm-and-down">
        <v-icon>mdi-google-maps</v-icon>
        {{ title }}
      </span>
      <v-spacer />
      <SwitchStudent :userId="getCurrentUser.id" class="mt-12"></SwitchStudent>
      <span class="font-weight-light"></span>
      <v-btn class="ml-14" fab x-small color="red" @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped :color="getThemeColor">
      <v-list dense :color="getThemeColor" dark>
        <template v-for="(item, i) in items">
          <v-row
            v-if="item.heading"
            :key="i + Math.random() + Math.random()"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn small text>edit</v-btn>
            </v-col>
          </v-row>
          <v-divider
            v-else-if="item.divider"
            :key="i + Math.random() + Math.random()"
            dark
            class="my-4"
          />

          <v-list-item
            v-else-if="getCurrentUser.alevel >= item.alevel"
            :key="i + Math.random() + Math.random()"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title @click="routeTo({ name: item.route })">{{
                item.text
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-if="getTakePhotos.includes(getCurrentUser.email)">
          <v-list-item-action>
            <v-icon @click="goToTakePhotos()">mdi-camera</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title @click="goToTakePhotos()"
              >Take Photos</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-action>
            <v-icon @click="signOut">exit_to_app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title @click="signOut">Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <slot />
    <Loader />
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import helpersJs from "@/plugins/helpers";
import SwitchSchool from "@/components/myLibrary/SwitchSchool.vue";
import SwitchStudent from "@/components/myLibrary/SwitchStudent.vue";
import { mapGetters } from "vuex";

export default {
  mounted() {
    const isMobile = this.$vuetify.breakpoint.isMobile;
    this.$store.commit("setIsMobile", isMobile);
  },
  updated() {
    const isMobile = this.$vuetify.breakpoint.mobile;
    this.$store.commit("setIsMobile", isMobile);
  },
  components: {
    Loader,
    SwitchSchool,
    SwitchStudent,
  },
  computed: mapGetters([
    "getAccessToken",
    "getCurrentUser",
    "getThemeColor",
    "getAppName",
    "getUserSchool",
    "getTakePhotos",
  ]),

  props: {
    source: String,
    title: String,
  },
  data: () => ({
    drawer: false,

    items: [
      { icon: "apps", text: "Switchboard", route: "switchboard", alevel: 1 },
      { icon: "touch_app", text: "Home", route: "school-website", alevel: 1 },
      {
        icon: "mdi-office",
        text: "Learning Materials",
        route: "learning-materials",
        alevel: 1,
      },
      {
        icon: "mdi-card-account-details",
        text: "Manage ID Cards",
        route: "manage-id-cards",
        alevel: 7,
      },

      { divider: true },

      { heading: "Database" },
      // { icon: "add", text: "Manage Topics", route: "crud-topics", alevel: 15 },
      // { icon: "add", text: "Manage Lessons", route: "crud-lesson", alevel: 15 },
      {
        icon: "mdi-database-plus",
        text: "Admin Database",
        route: "manage-datatables",
        alevel: 7,
      },
      {
        icon: "mdi-database-plus",
        text: "School Admin",
        route: "school-admin-switchboard",
        alevel: 7,
      },
      {
        icon: "mdi-cash-multiple",
        text: "School Finances",
        route: "finance-switchboard",
        alevel: 9,
      },
      {
        icon: "mdi-table",
        text: "Manage Staff",
        route: "manage-employees",
        alevel: 9,
      },
      {
        icon: "mdi-account-group",
        text: "Manage Users",
        route: "manage-users",
        alevel: 7,
      },

      {
        icon: "mdi-cog",
        text: "School Profile",
        route: "settings",
        alevel: 7,
      },
      {
        icon: "mdi-image-multiple",
        text: "Manage Site",
        route: "website-dashboard",
        alevel: 7,
      },

      { divider: true },
      { heading: "Elearning" },
      {
        icon: "mdi-book",
        text: "Bits-Elearning",
        route: "crud-elearning",
        alevel: 1,
      },
      { divider: true },
    ],
  }),
  methods: {
    routeTo(routeObj) {
      this.$router.push(routeObj);
    },
    goBack() {
      this.$router.back();
    },
    goToTakePhotos() {
      this.$router.push({ path: "/take-photos" });
    },
    async signOut() {
      await helpersJs.signOut();
    },
  },
};
</script>

<style scoped>
#keep .v-navigation-drawer__border {
  display: none;
}
</style>
